import gql from 'graphql-tag';

export const CANCEL_ACTIVITY_BOOKING = gql`
  mutation cancelActivityBooking($ids: [Int]!, $token: String) {
    cancelActivityBooking(ids: $ids, token: $token) {
      ok
    }
  }
`;

export const CANCEL_ACCOMMODATION_BOOKING = gql`
  mutation cancelAccommodationBooking($id: Int!, $token: String) {
    cancelAccommodationBooking(id: $id, token: $token) {
      id
    }
  }
`;

export const HANDLE_ACTIVITY_BOOKING = gql`
  mutation handleActivityBooking($id: Int!, $isHandled: Boolean!) {
    handleActivityBooking(id: $id, isHandled: $isHandled) {
      id
    }
  }
`;

export const HANDLE_ACCOMMODATION_BOOKING = gql`
  mutation handleAccommodationBooking($id: Int!, $isHandled: Boolean!) {
    handleAccommodationBooking(id: $id, isHandled: $isHandled) {
      id
    }
  }
`;

export const ACCOMMODATION_BOOKING_NOTES = gql`
   mutation AccommodationBookingNotes($id: Int!, $accommodationBookingNotes: AccommodationBookingNotesInput!) {
    accommodationBookingNotes(id: $id, accommodationBookingNotes: $accommodationBookingNotes) {
      id
    }
  }
`;

export const ACTIVITY_BOOKING_NOTES = gql`
  mutation ActivityBookingNotes($id: Int!, $activityBookingNotes: ActivityBookingNotesInput!) {
    activityBookingNotes(id: $id, activityBookingNotes: $activityBookingNotes) {
      id
    }
  }
`;


export const CANCEL_RENTAL_ITEMS_BOOKING = gql`
  mutation cancelRentalItemsBooking($ids: [Int]!, $token: String) {
    cancelRentalItemsBooking(ids: $ids, token: $token) {
      ok
    }
  }
`;


export const RENTAL_ITEMS_BOOKING_NOTES = gql`
  mutation RentalItemsBookingNotes($id: Int!, $rentalItemsBookingNotes: RentalItemsBookingNotesInput!) {
    rentalItemsBookingNotes(id: $id, rentalItemsBookingNotes: $rentalItemsBookingNotes) {
      id
    }
  }
`;

